import { AbstractPreset, config } from "./AbstractPreset";

export default class RectangleNoneCustom extends AbstractPreset {
	getName(): string {
		return 'rectangleNoneCustom';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "rectangle",
				"presetShape": this.getName(),
				"primitives": {
					"width": 50,
					"length": 50
				},
			},
			"drillholes": {
				"type": "custom",
				"settings": [
					{
						"x": 250,
						"y": 150,
					},
					{
						"x": 400,
						"y": 350,
					},
					{
						"x": 150,
						"y": 300,
					}
				]
			},
			"cutouts": [],
		};
	}

}
